<template>
  <div class="tbody-loader" :style="rootStyle">
    <slot>
      <div class="text-center" style="min-width:150px;">
        <div class="text-secondary mb-2 small">{{ message }}</div>
        <div class="progress progress-sm">
          <div class="progress-bar progress-bar-indeterminate"></div>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'TableBodyLoader',
  props: {
    minHeight: { type: Number, default: 500 },
    message:   { type: String, default: '불러오는중...' },

    // ✅ 추가: 수직/수평 정렬과 Y축 오프셋
    align:   { type: String, default: 'center', validator: v => ['start','center','end'].includes(v) },
    justify: { type: String, default: 'center', validator: v => ['start','center','end'].includes(v) },
    offsetY: { type: [Number, String], default: 0 }, // 예: -12
  },
  computed: {
    rootStyle() {
      const map = { start: 'flex-start', center: 'center', end: 'flex-end' }
      return {
        minHeight: this.minHeight + 'px',
        alignItems: map[this.align],       // 교차축(수직) 정렬
        justifyContent: map[this.justify], // 주축(수평) 정렬
        transform: this.offsetY ? `translateY(${this.offsetY}px)` : undefined
        // 필요하면 marginTop로 바꿔도 됩니다: marginTop: this.offsetY + 'px'
      }
    }
  }
}
</script>

<style scoped>
.tbody-loader {
  display: flex;
  /* align-items / justify-content 는 props로 덮어씀 */
  padding: 1rem;
}
/* progress (Tabler 스타일 발췌) */
.progress {
  display: flex;
  height: 0.5rem;
  overflow: hidden;
  font-size: 0.65625rem;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: .25rem;
  box-shadow: inset 0 1px 2px rgba(0,0,0,.075);
  position: relative;
  width: 100%;
  line-height: .5rem;
  appearance: none;
}
.progress-sm { height: .25rem; }
.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #206bc4;
  transition: width 0.6s ease;
  height: 100%;
}
@keyframes progress-indeterminate {
  0%   { right: 100%; left: -35%; }
  60%,100% { right: -90%; left: 100%; }
}
.progress-bar-indeterminate::before,
.progress-bar-indeterminate::after {
  position: absolute;
  top: 0; bottom: 0; left: 0;
  content: "";
  background-color: inherit;
  will-change: left, right;
}
.progress-bar-indeterminate::before {
  animation: progress-indeterminate 1.5s cubic-bezier(.65,.815,.735,.395) infinite;
}
</style>
